import { $Window } from 'app/services';

export class LodeRunnerService {

    /*=============================================================
        __              __        ____
       / /   ____  ____/ /__     / __ \__  ______  ____  ___  _____
      / /   / __ \/ __  / _ \   / /_/ / / / / __ \/ __ \/ _ \/ ___/
     / /___/ /_/ / /_/ /  __/  / _, _/ /_/ / / / / / / /  __/ /
    /_____/\____/\__,_/\___/  /_/ |_|\__,_/_/ /_/_/ /_/\___/_/

    ==================================|-|==========================
                      ()              |-|
                     /|\              |-|            ___
                     / \\             |-|           { $ }
    ========|-|==========  ========================================
            |-|
            |-|                          ___
            |-|                         { $ }
    ===============================================================
    */
    /**
     * Check current org for Motherlode property and apply #id
     * to the body element if property exists and is set to true
     *
     */
    public static checkLode(org) {
        if (org.is_motherlode) {
            $Window.body.classList.add('motherlode');
            return;
        } else {
            $Window.body.classList.remove('motherlode');
            return;
        }
    }
}
